import { render } from "./PatientStatement.vue?vue&type=template&id=4daf44c6&scoped=true"
import script from "./PatientStatement.vue?vue&type=script&lang=js"
export * from "./PatientStatement.vue?vue&type=script&lang=js"

import "./PatientStatement.vue?vue&type=style&index=0&id=4daf44c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4daf44c6"]])

export default __exports__